import $ from 'jquery';
import Messaging from '../ui/Messaging';
import PromoCode from './api/tnew/system/PromoCode';
import UrlHelper from './ajax/UrlHelper';
import { formButtonHandler } from '../tnew';

function handleFailure(x) {
  Messaging.clearErrors();

  if (x.status < 500) {
    const message = x.responseJSON.message;
    Messaging.addError(message);
    return;
  }

  if (x.status >= 500) {
    window.location.href = '/error';
  }
}

class PromoCodeProvider {
  constructor() {
    $(document).ready(() => {
      $('#tn-apply-promo').on('submit', (e) => {
        e.preventDefault();

        const promo = $('.tn-subnav-promo-code').val();
        const service = new PromoCode();

        Messaging.clear();

        service.post(promo)
          .done(() => {
            const urlHelper = new UrlHelper();
            const url = urlHelper.updateQueryStringParameter(window.location.href, 'promoApplied', 'true');
            window.location.href = url;
          })
          .fail(handleFailure)
          .always(() => {
            formButtonHandler.resetButtonStyling();
          });
      });


      $('#tn-remove-promo').on('submit', (e) => {
        e.preventDefault();

        const service = new PromoCode();

        service.delete()
          .done(() => {
            window.location.reload();
          })
          .fail(handleFailure)
          .always(() => {
            formButtonHandler.resetButtonStyling();
          });
      });
    });
  }
}

export default PromoCodeProvider;



// WEBPACK FOOTER //
// ./V7/tnew/lib/PromoCodeProvider.js